var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", [_vm._v("Recent Activity")]),
    _vm._v(" "),
    _vm.state === _vm.State.error
      ? _c("div", [_vm._v(_vm._s(_vm.errMsg))])
      : _vm.messages.length
      ? _c("div", [
          _c("table", { staticClass: "table" }, [
            _c(
              "tbody",
              _vm._l(_vm.messages, function(message) {
                return _c("tr", { key: message.id }, [
                  _c("td", [
                    _c("a", { attrs: { href: message.link } }, [
                      _c("img", {
                        attrs: { src: message.icon, height: "30", width: "30" }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(_vm._s(message.subtitle) + " "),
                    _c("span", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(message.date))
                    ])
                  ])
                ])
              }),
              0
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === _vm.State.loading
      ? _c("div", { staticClass: "d-flex justify-content-center" }, [
          _c("div", { staticClass: "spinner" })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === _vm.State.requestLoadMore
      ? _c("div", [
          _vm._v(
            "\n    No " +
              _vm._s(_vm.messages.length ? "more" : "") +
              " activity from the past month. "
          ),
          _c(
            "span",
            {
              staticClass: "btn-link",
              on: {
                click: function($event) {
                  return _vm.setDeltaToYear()
                }
              }
            },
            [_vm._v("Load more activity")]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { attrs: { id: "scrollTrigger" } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }